















































































































import SharedFunctions from '../SharedFunctions'
import { Component } from 'vue-property-decorator'
import Icon from '@/components/Icon.vue'
import Confirm from '@/components/Confirm.vue'
import Switcher from '@/components/Switcher.vue'
import Modal from '@/components/Modal.vue'
import { EUserPermissions, IResidentContact, IResidentRecipient, IStatement } from '@zunta/configurations'
import { User } from '@/classes/User'
import Api from '@/api'

@Component({
  components: { Modal, Confirm, Icon, Switcher }
})
export default class StatementsStatusesActions extends SharedFunctions {
  showModal: boolean = false
  EUserPermissions: typeof EUserPermissions = EUserPermissions
  user: User = Api.getUser() as User

  get recipient (): IResidentRecipient {
    return (this.selectedStatement as IStatement).recipient as IResidentRecipient
  }

  get mailContact (): IResidentContact {
    return this.recipient.mailContact as IResidentContact
  }

  get badMailAddress () {
    return this.mailContact && this.mailContact.badMailAddress
  }

  get show () {
    return this.selectedStatement && !this.mailedStatuses.includes(this.selectedStatement.status)
  }

  changeStatusToAccept () {
    if (this.recipient && this.badMailAddress) {
      this.toggleModal(true)
      return
    }
    this.changeStatus(this.currentStatementApproveStatus, true)
  }

  mounted () {
    this.$eventBus.$on('statementReview:changeStatusConfirmed', () => {
      this.changeStatus(this.currentStatementApproveStatus)
    })
  }

  toggleModal (value: boolean) {
    this.showModal = value
  }

  beforeDestroy () {
    this.$eventBus.$off('statementReview:changeStatusConfirmed')
  }
}
